import React from 'react';
import {Helmet} from 'react-helmet';
import PropTypes from 'prop-types';
import {removeFalsyValuesInArray} from '../../utils/utils';

const getListItem = (position, url) => `
        {
            "@type": "ListItem",
            "position": ${position},
            "url": "${url}"
        }
`;

const getItemList = (listItems) => `
{
    "@context": "http://schema.org",
    "@type": "ItemList",
    "ItemListElement": [
        ${listItems}
    ]
}
`;

export default function JsonSchema({
    category,
    systemData,
    featuredArticles,
    homeRoute,
    canonical,
}) {
    const {hostname, basePath, humanReadableName, siteName} = systemData;
    const logoUrl = `https://csvcus.homeaway.com/rsrcs/cdn-logos/3.4.0/bce/moniker/${siteName}/logo-bceheader.png`;
    const listItems = removeFalsyValuesInArray(featuredArticles).map(
        (article, index) => {
            const url = `https://${hostname}${basePath}${homeRoute}${category.path}/${article.slug}`;
            return getListItem(index + 1, url);
        },
    );

    return (
        <Helmet>
            {listItems.length && (
                <script type="application/ld+json">
                    {getItemList(listItems)}
                </script>
            )}

            <script type="application/ld+json">
                {`{
                        "@context": "http://schema.org",
                        "@type": "Article",
                        "genre": "travel",
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": "${canonical}"
                        },
                        "datePublished": "${category.sys.firstPublishedAt}",
                        "dateModified": "${category.sys.publishedAt}",
                        "headline": "${category.headline}",
                        "author": {
                            "@type": "Organization",
                            "name": "${humanReadableName}"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "${humanReadableName}",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "${logoUrl}"
                            }
                        }
                        ${
                            category.image
                                ? `,"image": "${category.image.url}"`
                                : ''
                        }
                    }`}
            </script>
        </Helmet>
    );
}

JsonSchema.propTypes = {
    category: PropTypes.shape({
        sys: PropTypes.shape({
            firstPublishedAt: PropTypes.string,
            publishedAt: PropTypes.string,
        }),
        path: PropTypes.string,
    }).isRequired,
    systemData: PropTypes.shape({
        hostname: PropTypes.string,
        basePath: PropTypes.string,
        humanReadableName: PropTypes.string,
        siteName: PropTypes.string,
    }).isRequired,
    featuredArticles: PropTypes.arrayOf(
        PropTypes.shape({
            slug: PropTypes.string,
        }),
    ).isRequired,
    homeRoute: PropTypes.string.isRequired,
    canonical: PropTypes.string.isRequired,
};
